export default __webpack_public_path__ + "static/media/js_icon.7f244515.png";